<h2 mat-dialog-title>{{ 'FRONTEND.SALES_UI.PIPELINE.SAVE_FILTER_DIALOG_TITLE' | translate }}</h2>

<mat-dialog-content>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'FRONTEND.SALES_UI.PIPELINE.FILTER_NAME_INPUT' | translate }}</mat-label>
    <input #name="ngModel" (ngModelChange)="checkIsDuplicate()" [(ngModel)]="filterGroupName" matInput required />
  </mat-form-field>
  <glxy-alert *ngIf="isDuplicate" type="warning">
    <strong>{{ 'FRONTEND.SALES_UI.COMMON.WARNING' | translate }}</strong>
    &mdash;
    {{ 'FRONTEND.SALES_UI.PIPELINE.FILTER_OVERWRITTEN_WARNING' | translate : { filterGroupName: filterGroupName } }}
  </glxy-alert>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-dialog-close mat-stroked-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  <button (click)="saveFilterGroup()" [disabled]="!name.valid" color="primary" mat-dialog-close mat-flat-button>
    {{ 'FRONTEND.SALES_UI.COMMON.ACTION_LABELS.SAVE' | translate }}
  </button>
</mat-dialog-actions>
